<template>
  <th
    :class="{sortable: isSortable, asc: sortedByColumn && !desc, desc: sortedByColumn && desc}"
    @click="sort"
  >{{ translate(columnLabel) }}<span class="indicator" v-if="isSortable"><svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M11.032 4H13v12.192l5.616-5.592 1.416 1.416-8.016 8.016L4 12.016 5.416 10.6l5.616 5.592V4z"></path></svg></span></th>
</template>

<script>
export default {
  props: {
    column: String,
    isSortable: {
      type: Boolean,
      default: false,
    },
    type: String,
    sortOrder: Array,
  },
  computed: {
    columnLabel() {
      return `columnHead${this.column.charAt(0).toUpperCase()}${this.column.slice(1)}`;
    },
    sortedByColumn() {
      if (!this.sortOrder || this.sortOrder.length === 0) {
        return false;
      }

      return this.sortOrder[0].by === this.column;
    },
    desc() {
      if (!this.sortOrder || this.sortOrder.length === 0 || this.sortOrder[0].by !== this.column) {
        return true;
      }

      return this.sortOrder[0].desc;
    },
  },
  methods: {
    sort() {
      if (this.isSortable) {
        this.$emit('sortOrderChanged', {
          by: this.column,
          desc: !this.desc,
          type: this.type,
        });
      }
    },
  },
};
</script>

<style lang="scss">
.loyalty-table {
  th.sortable {
    padding-right: rem(36px);
    cursor: pointer;

    .indicator {
      width: rem(18px);
      height: rem(40px);
      right: rem(12px);
      display: none;
      position: absolute;
      top: 0;
      opacity: .5;

      svg {
        fill: currentColor;
        position: absolute;
        top: 50%;
        transform: translate(0,-50%);
      }
    }

    &.desc,
    &.asc {
      .indicator {
        display: block;
        opacity: 1;

        svg {
          transition: transform 300ms;
        }
      }
    }

    &:hover .indicator {
      display: block;
    }

    &.desc .indicator svg {
      transform: translate(0,-50%) rotate(180deg);
    }
  }
}
</style>
